import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
//
import parlorSocialClub from "assets/graphics/icons/parlor-social-club-black.svg";
import logoWithLines from "assets/graphics/icons/logo-with-lines.svg";

import "screens/events/component/view.scss";
import "./view.scss";

// eslint-disable-next-line no-unused-vars
const ShareNominationView = ({ nominatedBy }) => (
  <main className="events__page nomination-page">
    <header className="nomination-page__header">
      <div className="nomination-page__logo--mobile">
        <Link to="/">
          <img src={logoWithLines} alt="" />
        </Link>
      </div>
      <div className="nomination-page__logo--desktop">
        <Link to="/">
          <img src={parlorSocialClub} alt="" />
        </Link>
      </div>
    </header>
    <div className="nomination-page__background-wrapper"></div>
    <section className="nomination-page__content-container">
      <div className="nomination-page__content-logo">
        <img src={logoWithLines} alt="" />
      </div>
      <h1 className="nomination-page__heading">
        You’ve been nominated by member {nominatedBy} to join Parlor Social
        Club.
      </h1>
      <p className="nomination-page__description">
        Parlor is a modern social club. Members enjoy a personalized calendar of
        social, cultural and professional events and an opportunity to connect
        with each other, both online and in person.
      </p>
      <p className="nomination-page__description nomination-page__description--secondary">
        You&apos;ve been invited as {`${nominatedBy.split(" ")[0]}'s`} guest
        <br />
        to check out an event.
      </p>
      <Link to="event" className="nomination-page__outlined-btn">
        See invitation
      </Link>
    </section>
  </main>
);

ShareNominationView.propTypes = {
  nominatedBy: PropTypes.string.isRequired,
  guestName: PropTypes.string.isRequired,
  isOnlineEvent: PropTypes.bool.isRequired,
};

export default ShareNominationView;
